import { OrderedMap, fromJS } from 'immutable';
import ToastActions from 'flux/actions/ToastActions';

export default {
  onCreateRoleCompleted() {
    ToastActions.saved();
  },

  onUpdateRoleCompleted() {
    ToastActions.saved();
  },

  onUpdateRoleFailed() {
    ToastActions.failed('Failed to update crew member.');
  },

  removeRoleEphemeral(userId) {
    this.setStateAndTrigger(this.getState().deleteIn(['list', userId]));
  },

  onRemoveRoleFailed() {
    ToastActions.failed('Failed to remove crew member');
  },

  getOrderedUserMap(userJsObj) {
    return OrderedMap(userJsObj.map((user) => [user._id, fromJS(user)]));
  },
};
